import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Sidebar from '../components/Sidebar';
// import './all.sass'
import './milo.css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet defaultTitle="ketostrive | your keto & low-carb resouce | kcko">
      <script src="/js/bundle.js" type="text/javascript" />
    </Helmet>
    <header role="banner">
      <Navbar />
    </header>
    <main className="main pt-4" role="main">
      <div className="container">

        <div className="row">
          <div className="col-md-9">
            {children()}
          </div>
          <div className="col-md-3 ml-auto">
            <Sidebar/>
          </div>
        </div>
      </div>
    </main>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js